export default __webpack_public_path__ + "static/media/img4.0144f3ef.png";